var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "service-autocomplete",
    _vm._b(
      {
        ref: "autocomplete",
        attrs: {
          dense: "",
          value: _vm.value,
          label: "Installation",
          url: _vm.url,
          solo: "",
          "cache-items": "",
          clearable: !_vm.readonly,
          readonly: _vm.readonly,
          "id-field": "id",
          "search-attributes-array": ["code", "shortname"],
          "use-entities": ""
        },
        on: { input: _vm.handleInputChange },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(item.code) +
                    " " +
                    _vm._s(item.shortname) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "selection",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(item.code) +
                    " " +
                    _vm._s(item.shortname) +
                    "\n    "
                ),
                _c(
                  "v-icon",
                  { on: { click: _vm.$refs.autocomplete.handleInputRemove } },
                  [_vm._v("mdi-close")]
                )
              ]
            }
          }
        ])
      },
      "service-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }